import Tag from './Tag';
import { TagProps, TagValueProps } from './types';

export type { TagProps, TagValueProps };
export default Tag;
